export function getChallengeWorkoutPlan(challenge) {
	if (!challenge) return null;

	const plan = challenge.workout_plan || challenge.custom_params?.workout_plan;
	if (!plan?.title || !Array.isArray(plan.days) || plan.days.length === 0) {
		return null;
	}

	return plan;
}

export function challengeHasWorkoutPlan(challenge) {
	return Boolean(getChallengeWorkoutPlan(challenge));
}
